export default class ResultTest {
  constructor(message, line, key) {
    this.message = message;
    this.line = line;
    this.key = key;
  }
}
